import { type Dispatch, useCallback } from 'react';

import actions from '../../../prepackage/prePackageActions';
import type { AutocompleteOption } from '../../../../types/index';

export const useDestinationHandler = (dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>) => {
    return useCallback(
        (option: AutocompleteOption | null, typedText?: string) => {
            if (!option && typedText) {
                dispatch(actions.setRawDestination(typedText));
            } else if (!option) {
                dispatch(actions.clearDestination());
            } else if (option.id === 'default') {
                dispatch(actions.resetDestinationOnly());
            } else {
                dispatch(actions.setDestination(option));
            }
        },
        [dispatch],
    );
};
